// extracted by mini-css-extract-plugin
module.exports = {"box":"DialogGift_box_TZUki","content":"DialogGift_content_5lmVc","title":"DialogGift_title_1vnWI","icon":"DialogGift_icon_2zSOF"};